var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"status-chip",attrs:{"small":"","label":"","color":_vm.resolved.color,"outlined":_vm.outlined,"dark":!_vm.outlined && _vm.resolved.darkText,"light":!_vm.outlined && !_vm.resolved.darkText}},[(_vm.icon)?_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }